/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Autocomplete, Button, Checkbox, DatePicker, Form, Grid, InfoTooltip, Input, Modal, Select, Stepper,
} from 'framework-ui-components';

class ModaleCreaSuccessione extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 1,
      modello4attivo: window.config.toggleSuccessioniModello4 === 'true',
    };

    this.initializeComponent();
  }

  initializeComponent() {
    this.avanti = this.avanti.bind(this);
    this.indietro = this.indietro.bind(this);
    this.crea = this.crea.bind(this);
  }

  avanti() {
    const { currentStep } = this.state;
    if (currentStep === 1) {
      if (this.form.valida()) {
        this.setState({ currentStep: 2 });
      }
    } else if (currentStep === 2 || currentStep === 3) {
      this.setState({ currentStep: currentStep + 1 });
    }
  }

  indietro() {
    const { currentStep } = this.state;
    if (currentStep !== 1) {
      this.setState({ currentStep: currentStep - 1 });
    }
  }

  crea() {
    const { onCrea } = this.props;
    onCrea && onCrea(this.state);
  }

  stepState(stepNumber) {
    const { currentStep } = this.state;
    if (stepNumber === currentStep) {
      return Stepper.State.ACTIVE;
    }
    if (stepNumber < currentStep) {
      return Stepper.State.DONE;
    }
    return Stepper.State.TODO;
  }

  render() {
    const { showModal, onClose } = this.props;
    const {
      currentStep, Modalita, DataDecesso, Tipo, modello4attivo,
    } = this.state;

    const modalitaTelematica = 'telematica';
    const modalitaCartacea = 'cartacea';

    // elenco tipologie per modalità
    // il codice assegnato è quello definito negli eventi dichiarativi
    const tipologieDichiarazione = [
      { modalita: modalitaTelematica, codice: '0', descrizione: 'Prima dichiarazione' },
      { modalita: modalitaTelematica, codice: '13', descrizione: 'Sostitutiva con nuova trascrizione e voltura' },
      { modalita: modalitaTelematica, codice: '14', descrizione: 'Sostitutiva senza nuova trascrizione e voltura' },
      { modalita: modalitaTelematica, codice: '15', descrizione: 'Sostitutiva soli allegati' },
      { modalita: modalitaCartacea, codice: '32', descrizione: 'Prima dichiarazione' },
      { modalita: modalitaCartacea, codice: '33', descrizione: 'Modificativa' },
      { modalita: modalitaCartacea, codice: '34', descrizione: 'Integrativa' },
      { modalita: modalitaCartacea, codice: '35', descrizione: 'Sostitutiva' },
      { modalita: modalitaCartacea, codice: '36', descrizione: 'Aggiuntiva' },
    ];

    // avviso se usare il modello cartaceo o telematico
    // in base alla data di decesso
    const dataLimiteCartaceo = '2006-10-03T00:00:00.000Z';
    let suggerimentoModalita = false;
    let testoSuggerimentoModalita = '';
    if (Modalita === modalitaCartacea
      && Tipo === '32'
      && DataDecesso && DataDecesso >= dataLimiteCartaceo) {
      suggerimentoModalita = true;
      testoSuggerimentoModalita = 'Se la successione si è aperta successivamente al 02/10/2006 presentare dichiarazione telematica';
    } else if (Modalita === modalitaTelematica
      && DataDecesso && DataDecesso < dataLimiteCartaceo
    ) {
      suggerimentoModalita = true;
      testoSuggerimentoModalita = 'Se la successione si è aperta prima del 03/10/2006 presentare dichiarazione cartacea con modello 4';
    }

    return (
      <Modal show={showModal} onClose={onClose} className="creationDialog">
        <Modal.Header>Crea nuova successione</Modal.Header>
        <Modal.Body>
          <Stepper>
            <Stepper.Step title="Dati del defunto" state={this.stepState(1)}>
              <Form
                onChange={(x) => {
                  const newState = x;
                  if (x.Modalita && x.Modalita !== Modalita) { newState.Tipo = null; }
                  this.setState(newState);
                }}
                stato={this.state}
                ref={(r) => this.form = r}
              >
                {modello4attivo && (
                  <div>
                    <InfoTooltip className="info-modalita-dichiarazione" right>
                      <br />
                      <p>Il modello 4 va utilizzato solo nei seguenti casi:
                        <ul>
                          <li>la successione si è aperta prima del 3 ottobre 2006</li>
                          <li>va presentata un’integrativa quando la prima dichiarazione è stata presentata con questo modello</li>
                        </ul>
                      </p>
                    </InfoTooltip>
                    <Select title="Modalità" validations={['required']} name="Modalita">
                      <Select.Option value={null}>Seleziona la modalità di presentazione</Select.Option>
                      <Select.Option value={modalitaTelematica}>Telematica</Select.Option>
                      <Select.Option value={modalitaCartacea}>Cartacea (modello 4)</Select.Option>
                    </Select>
                  </div>
                )}

                <Select title="Tipo Dichiarazione" validations={['required']} name="Tipo">
                  <Select.Option value={null}>Seleziona il tipo di dichiarazione</Select.Option>
                  {tipologieDichiarazione
                    .filter((x) => {
                      if (modello4attivo) {
                        return x.modalita === Modalita;
                      }
                      return x.modalita === modalitaTelematica;
                    })
                    .map((y) => (<Select.Option key={y.codice} value={y.codice}>{y.descrizione}</Select.Option>))}
                </Select>

                <Input title="Codice Fiscale" name="CodiceFiscale" validations={['required', 'CodiceFiscaleAlfaNumerico']} />
                <Grid.Row>
                  <Grid.Col md="6">
                    <Input title="Cognome" name="Cognome" validations={['required']} />
                  </Grid.Col>
                  <Grid.Col md="6">
                    <Input title="Nome" name="Nome" validations={['required']} />
                  </Grid.Col>
                </Grid.Row>

                <Select title="Tipo di Devoluzione" validations={['required']} name="TipoDevoluzione">
                  <Select.Option value={null}>Seleziona il tipo di devoluzione</Select.Option>
                  <Select.Option value="0">Per Legge</Select.Option>
                  <Select.Option value="1">Per Testamento</Select.Option>
                  <Select.Option value="2">Entrambi</Select.Option>
                </Select>
                {suggerimentoModalita
                  && (
                    <InfoTooltip right type="warning" className="info-data-morte">
                      <p> </p>
                      {testoSuggerimentoModalita}
                    </InfoTooltip>
                  )}
                <DatePicker
                  title="Data del decesso o morte presunta"
                  name="DataDecesso"
                  validations={[(x) => (!(`${x || ''}`).trim() && 'Campo obbligatorio') || null]}
                />
                <Autocomplete
                  title="Comune ultima residenza"
                  minLength={2}
                  name="ComuneUltimaResidenza"
                  url="/Successioni/Comuni"
                  validations={[(x) => (!(`${x || ''}`).trim() && 'Campo obbligatorio') || null]}
                  onChange={(t) => this.setState({ CodiceComune: t.Codice, ComuneUltimaResidenza: t.Description, ProvinciaUltimaResidenza: t.Provincia })}
                />
                <br />
                <label>E&apos; stata dichiarata l&apos;assenza o morte presunta con sentenza del tribunale? <Checkbox name="FlagMortePresunta" switch /></label>
              </Form>
            </Stepper.Step>
            <Stepper.Step title="Immobili" state={this.stepState(2)}>
              <Form onChange={(x) => this.setState(x)} stato={this.state}>
                <label>Il defunto possedeva Terreni? <Checkbox name="QuadroEb" switch /></label>
                <br />
                <label>Il defunto possedeva Fabbricati? <Checkbox name="QuadroEc" switch /></label>
                <br />
                <label>Il defunto possedeva Terreni nei territori ove vige il sistema tavolare? <Checkbox name="QuadroEl" switch /></label>
                <br />
                <label>Il defunto possedeva Fabbricati nei territori ove vige il sistema tavolare? <Checkbox name="QuadroEm" switch /></label>
              </Form>
            </Stepper.Step>
            <Stepper.Step title="Altri beni" state={this.stepState(3)}>
              <Form onChange={(x) => this.setState(x)} stato={this.state}>
                <label>Il defunto possedeva aziende o rami di esse? <Checkbox name="QuadroEn" switch /></label>
                <br />
                <label>Il defunto possedeva azioni, obbligazioni, altri titoli e quote sociali? <Checkbox name="QuadroEo" switch /></label>
                <br />
                <label>Il defunto possedeva denaro, gioielli/mobilia, rendite/pensioni, crediti?  <Checkbox name="QuadroEr" switch /></label>
                <br />
                <label>Aereomobili che non fanno parte di aziende <Checkbox name="QuadroEp" switch /></label>
                <br />
                <label>Navi e imbarcazioni che non fanno parte di aziende <Checkbox name="QuadroEq" switch /></label>
              </Form>
            </Stepper.Step>
            <Stepper.Step title="Passivita'" state={this.stepState(4)}>
              <Form onChange={(x) => this.setState(x)} stato={this.state}>
                <label>Sono presenti debiti o eventuali oneri che gravano sulle quote ereditarie? <Checkbox name="QuadroEd" switch /></label>
              </Form>
            </Stepper.Step>
          </Stepper>

        </Modal.Body>
        <Modal.Footer>
          <Button flat onClick={onClose}>Annulla</Button>
          {currentStep !== 1 && <Button flat onClick={this.indietro}>Indietro</Button>}
          {currentStep !== 4 && <Button flat primary onClick={this.avanti}>Avanti</Button>}
          {currentStep === 4 && <Button flat primary onClick={this.crea}>Crea</Button>}
        </Modal.Footer>
      </Modal>
    );
  }
}

ModaleCreaSuccessione.propTypes = {
  onClose: PropTypes.func.isRequired,
  onCrea: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
};

export default ModaleCreaSuccessione;
